import { NotificationTypes, VoyNotification } from "../../services/types/vessel-notifications-services.types";

export interface activityLogNotification {
    id: string
    created_at: string
    url?: string
    requestType?: string // HTTP method
    status?: 'submitted' | 'complete' | 'failed'
    details?: any
    type: string // Notification type
    title?: string
    icon?: any // Icon data
    description?: string
    requiresAction? : boolean
}


export enum VesselNotificationsEventNames {
    NotificationsUpdated = 'notifications-updated',
}

export enum NotificationTypesExtended {
    Alarm = "Alarm",
    EtaDeviation = "eta-deviation",
    NPS = "NPS",
    HeavyWeather = "heavyweather",
    ParametricRoll = "parametricroll",
    HeavyRolling = "heavyrolling",
    HighAccelerationForce = "highaccelerationforce",
    ETAAlerts = "eta-alerts",
    NoPlanPreEtd = "no_plan_pre_dept",
    Sync = "sync",
    BasicPlan= "basicPlan",
    SlowNetwork= "slowNetwork",
}


export type UnifiedNotification =
    | VoyNotification<NotificationTypes.Alarm>
    | VoyNotification<NotificationTypes.EtaDeviation>
    | VoyNotification<NotificationTypes.NPS>
    | VoyNotification<NotificationTypes.HeavyWeather>
    | VoyNotification<NotificationTypes.ParametricRoll>
    | VoyNotification<NotificationTypes.HeavyRolling>
    | VoyNotification<NotificationTypes.HighAccelerationForce>
    | VoyNotification<NotificationTypes.ETAAlerts>
    | VoyNotification<NotificationTypes.NoPlanPreEtd>
    | activityLogNotification
